module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('slider'), _vm._v(" "), _c('index-boxes'), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#141e36",
      "color": "#fff"
    }
  }, [_c('div', {
    staticClass: "container pd-50"
  }, [_c('h1', {
    staticStyle: {
      "font-size": "30px",
      "color": "#fff",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n                Transportfirma\n            ")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "20px",
      "color": "#fff",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n                Transportfirma, Fragt og Vognmand P. Pedersen & Søn Ærø\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Vi er en solid og velkonsolideret transportvirksomhed med flere årtier på bagsmækken, som dagligt leverer en bred vifte af services til vores kunder. Hos os er der mulighed for at få transporteret mange forskellige slags gods. Vi kan håndtere en eller flere afhentninger af alt fra den mindste kolli op til 38 tons pr. gang.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Vi kan med stolthed sige, at transport er en del af vores DNA. Vi er stolte af vores virksomhed og vores omhyggelige engagerede medarbejdere. Vi behandler godset som var det firmaets eget. Vi yder vores bedste hver dag i bestræbelserne på at give den bedst mulige service overfor vores kunder.\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_c('contact-cta')], 1), _vm._v(" "), _c('p', [_vm._v("\n                Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har altid haft en klar holdning til kvalitet, professionel håndtering, høj service og rettidig distribution. \n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Det er vigtigt for os at du har tillid til os, hvilket vi vægter højt i vores transportfirma. Vores medarbejdere er vores største styrke. Omgangstonen er uformel og vi har stor tillid til hinanden. Alle vores medarbejdere er motiverede og ansvarsbevidste, og de har en positiv tilgang til vores samarbejde med vores kunder. \n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Vi fokuserer på punktlighed hvilket betyder, at du får dine leverancer til tiden. Vi har professionelle chauffører som er uddannet til at håndtere alle typer af gods.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Du kan stole på, at transportere vi dine pakker eller gods – så bliver det ansvarligt behandlet og kommer sikkert frem, da du altid får en kompetent chauffør til jobbet.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("\n            Transportfirma i Danmark\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Fragt og Vognmandsfirma P. Pedersen & Søn Ærø er et transportfirma som gennem samarbejde med anerkendte transportører, kan betjene kunder i hele landet. Alle vores kunder har forskellige behov for transport, og vi gør altid vores bedste for at imødekomme disse ønsker og behov. Vi har den nødvendige viden og erfaring til at tilbyde dig individuelle ydelser, og til at skræddersy løsninger til både private- og erhvervskunder.\n        ")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "20px"
    }
  }, [_vm._v("\n            Kurerkørsel af forskellige slags\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Kurerkørsel er en transportmulighed, for de af vores kunder som skal have transporteret noget her og nu og gerne til en specifik adresse.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har store erfaringer med kurerkørsel af hasteleveringer til hele landet.  Vi er i tæt dialog med vores kunder, hvor vi forventningsafstemmer og snakker om dine individuelle behov. Vi afdækker gennem en indledende samtale, hvilken opgave og hvilken vare I måtte have behov for at få kurerkørsel af.\n        ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n            Vi ønsker at afdække disse behov bedst muligt med vores fleksible og professionelle løsninger. Vi er også af den overbevisning, at du som kunde hos os ikke skal betale for mere end højst nødvendigt, og fordi vi ønsker at være konkurrencedygtige.\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin": "30px 0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('contact-cta')], 1), _vm._v(" "), _c('p', [_vm._v("\n            Hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har du mulighed for at få transporteret mange forskellige slags gods.\n        ")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "container pd-50",
    attrs: {
      "id": "miljo"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('h4', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                    Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har fokus på miljø og sikkerhedskrav\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Fragt og Vognmandsfirma P. Pedersen & Søn Ærø ved at vores virksomhed er med til at påvirke miljøet og det samfund vi er en del af bl.a. gennem CO2udslip. Derfor udskifter vi løbende vores biler så vi overholder gældende EU-normer. \n                ")]), _vm._v(" "), _vm._m(3), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('contact-cta')], 1)]), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _vm._m(10)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Samtalen vil bl.a. indeholde:\n            "), _c('ul', [_c('li', [_vm._v("Er det en hastesag?")]), _vm._v(" "), _c('li', [_vm._v("Hvad skal leveres?")]), _vm._v(" "), _c('li', [_vm._v("Hvor lang er ruten?")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "href": "/fragtfirma"
    }
  }, [_vm._v("\n                    Læs mere\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#edf2f7",
      "padding": "30px 0",
      "border-top": "1px solid #ddd",
      "border-bottom": "1px solid #ddd"
    }
  }, [_c('div', {
    staticClass: "container pd-50"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "20px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    Stykgods / Partigods\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Når du vælger Fragt og Vognmandsfirma P. Pedersen & Søn Ærø til distribution af dit stykgods i Danmark, vælger du et vognmandsfirma, som ønsker at være den forlængede arm ud til dig. Det betyder du med ro kan stole på, at vi transporterer dine varer sikkert, og at varerne når frem i tide i korrekt tilstand.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Stykgods eller partigods er en forsendelse som er over 20 kg. Vi har mulighed for at sende både enkeltvis, små kolli, eller større partier. Som ekstra service har vi også en medbringertruck til levering af dit gods, hvor vores fragtbiler ikke når ind.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Fragt og Vognmandsfirma P. Pedersen & Søn Ærø sender og henter dagligt småpakker og stykgods fra fastlandet til Ærø i tæt samarbejde med anerkendte transportører. Forsendelser afhentet hos en virksomhed eller indleveret på vores lager i Odense inden kl. 09:00 leveres samme dag hos modtager på Ærø. Fragt og Vognmandsfirma P. Pedersen & Søn kan betjene kunder i hele landet.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "href": "/transportloesninger/stykgods"
    }
  }, [_vm._v("\n                        Læs mere\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "20px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    Bulk / Walking floor\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Bulkgods betegner gods som transporteres u-pakket, dvs. løst (f.eks. forskellige kornarter, træpiller, flis etc.).\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Fragt og Vognmandsfirma P. Pedersen & Søn Ærø transporterer løst gods med Walking floor trailere, som via hydraulik kan flytte lameller som ligger i bunden af traileren frem og tilbage. På den måde læsses u-pakket løst gods af i stedet for at tippe traileren. \n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Vi mener det er den ideelle trailer til løst volume gods, da det er nemt og hurtigt at læsse godset af ved med det bevægelige gulv, og vi benytter Walking floor trailerne til flere formål.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Fragt og Vognmandsfirma P. Pedersen & Søn Ærø transporterer ikke alene løse foderstoffer, træflis og forskellige kornarter, men også træpiller og pallegods. Den ene Walking floor trailer kan åbnes i siden, hvilket gør det er muligt at laste og losse gods vandret i traileren. \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "href": "/transportloesninger/bulk"
    }
  }, [_vm._v("\n                        Læs mere\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "20px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    Køl / frys\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Transport af fryse- og kølevarer er en af Fragt og Vognmandsfirma P. Pedersen & Søn Ærø stærke kompetencer. Vi har vi nogle af landets mest moderne kølevogne, som alle opfylder markedets krav om køletransport til at fragte vores temperaturfølsomme gods. Hygiejnen er i højsæde, og vi sikre naturligvis at kølekæden ikke brydes under transporten. Det betyder du kan være sikker på at modtage dine varer med en garanteret friskhed. \n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Dagligt transporterer Fragt og Vognmandsfirma P. Pedersen & Søn Ærø temperaturfølsomme varer til butikker, cateringfirmaer, hoteller og restauranter til hele Ærø.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "href": "/transportloesninger/koel-frys"
    }
  }, [_vm._v("\n                        Læs mere\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "20px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    Farligt gods / fyrværkeri (ADR)\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Få transporteret dit farlige gods (ADR) hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø af professionelt uddannede og godkendte chauffører. \n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Vi sørger for at håndtere og transportere dit farlige gods (ADR) sikkert - uanset om der er tale om ilt, gas, cellulosefortynder, maling, fyrværkeri, krudt og kugler etc.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Hos os kan du altid trygt regne med at det farlig gods (ADR) er forsvarligt pakket og surret, og kommer sikkert frem fra afsender til modtager.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "href": "/transportloesninger/farligt-gods"
    }
  }, [_vm._v("\n                        Læs mere\n                    ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Fragt og Vognmandsfirma P. Pedersen & Søn Ærø:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-boxes fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Tager ansvar for kundernes varer\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-tree-alt fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Tager ansvar for miljøet\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-file-alt fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Har chauffører, som altid er opdaterede med gældende kurser og uddannelser med fokus på at nedbringe arbejdsulykker\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-thumbs-up fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Har chauffører, som viser respekt i lokalsamfundet og agere så de altid er til mindst muligt gene på vejene\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fal fa-file-certificate fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Har altid opdaterede tilladelser / certificeringer inden for fødevaresikkerhed og fødevarehygiejne, farligt gods mm. i henhold til gældende love og regler\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px"
    },
    attrs: {
      "src": "/static/images/snow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container pd-50"
  }, [_c('h4', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("\n            Lad vores Fragt og Vognmandsfirma transportere dit gods\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Hvis du vægter pålidelighed og professionalisme højt, så er vores Fragt og Vognmandsfirma P. Pedersen & Søn Ærø det helt rette valg for dig. Du får altid erfarne chauffører, der kender deres ansvar og opgaver. Vi har gode priser, og kan tilbyde dig et uforpligtende tilbud.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Skal vores Fragt og Vognmandsfirma P. Pedersen & Søn Ærø transportere dit gods sikkert frem? Vi er aldrig længere end et opkald væk.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Kontakt os allerede i dag ved at ringe på telefon 40 43 60 78 eller ved at sende en e-mail til karsten@p-pedersen.dk så vender vi hurtigst muligt tilbage.\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94c7567a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/index.vue
// module id = 273
// module chunks = 1